module.exports = __webpack_public_path__ + "img/2.dd411078.png";